// The shell's glyphs as DATA (After Hours shell.js path data, pipe-delimited paths).
// The renderer is the design system's `Icon`: `<Icon d={ICON_PATHS.bell} />`.

export const ICON_PATHS = {
  // primary rail — Ledger · Knowledge · Authority (Three Surfaces v5)
  ledger: 'M12 6.5v13.5|M12 6.5C10.2 5.1 7.4 4.6 4.5 4.6v12.6c2.9 0 5.7.5 7.5 1.9|M12 6.5c1.8-1.4 4.6-1.9 7.5-1.9v12.6c-2.9 0-5.7.5-7.5 1.9',
  knowledge: 'M12 11.6a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6z|M5.5 20a6.5 6.5 0 0 1 13 0',
  // The shield is Authority's glyph in the design; Admin gets its own below.
  authority: 'M12 3.5l7 2.6v4.7c0 4-2.9 6.9-7 8.2-4.1-1.3-7-4.2-7-8.2V6.1z|M9 11.6l2 2 4-4',
  value: 'M4.5 19.5h15|M7.5 19.5V13|M12 19.5V8|M16.5 19.5v-9',
  // theme toggle
  todaySun: 'M3 17.5h18|M7 17.5a5 5 0 0 1 10 0|M12 4v2.2|M5 9.5l1.5 1.5|M19 9.5l-1.5 1.5',
  tonightMoon: 'M21 12.8A8.5 8.5 0 1 1 11.2 3a6.6 6.6 0 0 0 9.8 9.8z',
  // legacy rail (Journal / Memory / Playbook) — still used by the pre-v5
  // screens until they are retired.
  journal: 'M12 6.5v13.5|M12 6.5C10.2 5.1 7.4 4.6 4.5 4.6v12.6c2.9 0 5.7.5 7.5 1.9|M12 6.5c1.8-1.4 4.6-1.9 7.5-1.9v12.6c-2.9 0-5.7.5-7.5 1.9',
  memory: 'M12 11.6a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6z|M5.5 20a6.5 6.5 0 0 1 13 0',
  // Playbook — the design's sliders/adjustments glyph (config, not chat)
  messaging: 'M21 4H14|M10 4H3|M21 12H12|M8 12H3|M21 20H16|M12 20H3|M14 2v4|M8 10v4|M16 18v4',
  // footer rail — a wrench, so Admin reads distinctly from Authority's shield
  admin: 'M14.7 6.3a4 4 0 0 0-5.4 5.4L4 17v3h3l5.3-5.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2-2z',
  docs: 'M7 3.5h7l4 4v13H7z|M14 3.5v4h4|M9.5 12.5h5|M9.5 16h3.5',
  // chrome
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM21 21l-5-5',
  bell: 'M18 8.5a6 6 0 0 0-12 0c0 6-2.5 7.5-2.5 7.5h17S18 14.5 18 8.5|M13.8 20a2 2 0 0 1-3.6 0',
  cog: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z|M19 12a7 7 0 0 0-.1-1l2-1.6-2-3.4-2.3 1a7 7 0 0 0-1.7-1l-.3-2.5h-4l-.3 2.5a7 7 0 0 0-1.7 1l-2.3-1-2 3.4 2 1.6a7 7 0 0 0 0 2l-2 1.6 2 3.4 2.3-1a7 7 0 0 0 1.7 1l.3 2.5h4l.3-2.5a7 7 0 0 0 1.7-1l2.3 1 2-3.4-2-1.6a7 7 0 0 0 .1-1z',
  team: 'M9 8m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0|M3 20a6 6 0 0 1 12 0|M16 6a3 3 0 0 1 0 5',
  signout: 'M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3|M10 17l-5-5 5-5M5 12h11',
  expand: 'M4 14v6h6|M20 10V4h-6|M20 4l-7 7|M4 20l7-7',
  // Ask page
  plus: 'M12 5v14|M5 12h14',
  send: 'M3 11l18-7-7 18-2.5-8L3 11z',
  // Ask dock (MAR-174): thread history, and the collapse chevron.
  clock: 'M12 8v5l3.5 2|M12 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15z',
  chevronRight: 'M9 6l6 6-6 6',
  askSend: 'M5 12h13|M12.5 6.5L19 12l-6.5 5.5',
} as const

export type IconName = keyof typeof ICON_PATHS
